"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const BackHeader_1 = __importDefault(require("../../assets/icons/BackHeader"));
const components_1 = require("../../components");
const rootNavigation_1 = require("../../navigators/rootNavigation");
const masterData_1 = require("../../utils/masterData");
const scale_1 = require("../../utils/scale");
const native_1 = require("@react-navigation/native");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const getPolicy = (index, itemIndex) => {
    const section = masterData_1.masterPolicies.find((_, idx) => index == idx);
    const item = section?.items.find((_, idx) => idx == itemIndex);
    return { title: section?.title, content: item?.content };
};
const TermOfUse = (props) => {
    const { index, itemIndex, from } = props.route.params;
    const { title, content } = getPolicy(index, itemIndex);
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const navigation = (0, native_1.useNavigation)();
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(react_native_1.View, { style: { zIndex: 100 } },
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: title || ' ', styleContainer: {
                    backgroundColor: 'white',
                }, leftIcon: react_1.default.createElement(BackHeader_1.default, null), onLeftPress: () => {
                    switch (from) {
                        case 'login':
                            navigation.goBack();
                            (0, rootNavigation_1.navigate)(Routes_1.default.AUTH_NAVIGATOR, { screen: Routes_1.default.LOGIN });
                            return;
                        case 'input_password':
                            navigation.goBack();
                            (0, rootNavigation_1.navigate)(Routes_1.default.AUTH_NAVIGATOR, { screen: Routes_1.default.LOGIN });
                            setTimeout(() => {
                                (0, rootNavigation_1.navigate)(Routes_1.default.INPUT_PASSWORD);
                            }, 0);
                            return;
                        default:
                            navigation.goBack();
                            return;
                    }
                } })),
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: [
                styles.body,
                {
                    paddingBottom: inset.bottom + (0, scale_1.scale)(120),
                },
            ], showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles.text },
                react_1.default.createElement("style", null, `
                            .policy-container-view {
                                font-family: 'Hiragino Kaku Gothic Pro W3', 'Hiragino Kaku Gothic Pro W6';
                            }
                        `),
                react_1.default.createElement("div", { className: "policy-container-view", dangerouslySetInnerHTML: { __html: content } })))));
};
exports.default = TermOfUse;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f7f7f7',
    },
    body: {
        paddingTop: (0, scale_1.scale)(24),
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    text: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
});
